;(function() {
  'use strict'

  Controller.$inject = ["$timeout", "Channel", "clipboardService", "glUtils", "glToast"];
  angular.module('app.core').component('channelListItemDashboard', {
    controller: Controller,
    templateUrl: 'channel-list-item-dashboard.html',
    bindings: {
      channel: '<',
      survey: '<',
    },
  })

  /* @ngInject */
  function Controller($timeout, Channel, clipboardService, glUtils, glToast) {
    var ctrl = this
    var Types = Channel.Type

    ctrl.copyToClipboard = clipboardService.copy
    ctrl.hasBasicStats = hasBasicStats
    ctrl.hasAdvancedStats = hasAdvancedStats
    ctrl.generatePanelLink = generatePanelLink

    ctrl.$onChanges = onChanges

    function onChanges() {
      ctrl.responsesLabel =
        ctrl.channel.responseCount +
        glUtils.numberSwitch(
          ctrl.channel.responseCount,
          ' response',
          ' responses'
        )

      if (ctrl.channel.exitCount || ctrl.survey.hasExitLogic()) {
        ctrl.exitsLabel =
          ctrl.channel.exitCount +
          glUtils.numberSwitch(ctrl.channel.exitCount, ' exit', ' exits')
      }

      if (ctrl.channel.quotaCount > 0) {
        ctrl.quotaHitsLabel = ctrl.channel.quotaCount + ' over-quota'
      }

      var reward = ctrl.channel.reward
      if (reward) {
        ctrl.spendPercentage =
          Math.round(
            (reward.currentSpend.amount / reward.spendTarget.amount) * 100
          ) + '%'
        ctrl.spendProgress =
          reward.currentSpend.format() + ' / ' + reward.spendTarget.format()
      }
    }

    function hasBasicStats() {
      return _.includes(
        [Types.CUSTOM, Types.PRODUCTS, Types.PLACES, Types.KIOSK],
        ctrl.channel.type
      )
    }

    function hasAdvancedStats() {
      return _.includes([Types.PANEL, Types.EXTERNAL_PANEL], ctrl.channel.type)
    }

    // this is a developer easter egg to help with testing panel channels in staging.
    // click the stats-bar quickly 4 times and a respondent link for hte panel is generated
    // and added to your clipboard
    var genCount = 0
    var genTimer
    function generatePanelLink() {
      genCount++
      if (genCount === 4) {
        var link = ctrl.channel.panel.getFakeRespondentLink()
        copyToClipboard(link)
        glToast.show('Copied to clipboard!')
        genCount = 0
      } else {
        $timeout.cancel(genTimer)
        genTimer = $timeout(function() {
          genCount = 0
        }, 700)
      }
    }
  }
})()
